import { GET_EMPLOYEESLIST } from "resources/actionTypes";

export function getEmployeesList(payloadData) {
  return {
    type: GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_REQUESTED,
    payload: payloadData,
  };
}

export function clearEmployeesList() {
  return {
    type: GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_CLEARED
  };
}